const DEVICE_ID_KEY = 'cpos_device_id';

// Returns a stable per-device UUID from localStorage, generating and persisting one on first use.
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) {
      return existing;
    }
    const generated = generateUuid();
    localStorage.setItem(DEVICE_ID_KEY, generated);
    return generated;
  } catch {
    return generateUuid();
  }
}

function generateUuid(): string {
  const cryptoObj = typeof crypto !== 'undefined' ? crypto : undefined;
  if (cryptoObj?.randomUUID) {
    return cryptoObj.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}
